import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { TESTIMONIALS } from "../../data/content";
import { Reveal } from "../motion/Motion";

export default function Testimonials() {
  const [index, setIndex] = useState(0);
  const active = TESTIMONIALS[index];

  const next = () => setIndex((i) => (i + 1) % TESTIMONIALS.length);
  const prev = () => setIndex((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section
      id="velemenyek"
      data-testid="testimonials-section"
      className="relative overflow-hidden bg-white py-20 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-20">
          <div className="lg:col-span-4">
            <Reveal>
              <p className="mb-5 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-brand-accent">
                <span className="h-px w-10 bg-brand-accent" />
                Vélemények
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-heading text-3xl font-extrabold leading-[1.08] tracking-tight text-brand-primary sm:text-4xl lg:text-5xl">
                Amit ügyfeleink mondanak rólunk
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-8 flex items-center gap-3">
                <button
                  data-testid="testimonial-prev"
                  onClick={prev}
                  className="grid h-12 w-12 place-items-center border border-brand-primary/20 text-brand-primary transition-colors hover:bg-brand-primary hover:text-white"
                  aria-label="Előző vélemény"
                >
                  <ChevronLeft size={20} />
                </button>
                <button
                  data-testid="testimonial-next"
                  onClick={next}
                  className="grid h-12 w-12 place-items-center border border-brand-primary/20 text-brand-primary transition-colors hover:bg-brand-primary hover:text-white"
                  aria-label="Következő vélemény"
                >
                  <ChevronRight size={20} />
                </button>
                <span className="ml-3 font-mono text-sm text-brand-primary/50">
                  {String(index + 1).padStart(2, "0")} / {String(TESTIMONIALS.length).padStart(2, "0")}
                </span>
              </div>
            </Reveal>
          </div>

          <div className="relative lg:col-span-8">
            <Quote
              size={80}
              className="absolute -top-6 right-0 text-brand-accent/15"
              fill="currentColor"
            />
            <AnimatePresence mode="wait">
              <motion.blockquote
                key={index}
                data-testid="testimonial-card"
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -24 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                className="relative"
              >
                <div className="flex gap-1">
                  {Array.from({ length: active.rating }).map((_, i) => (
                    <Star key={i} size={20} className="text-brand-accent" fill="currentColor" />
                  ))}
                </div>
                <p className="mt-6 font-heading text-xl font-medium leading-snug text-brand-primary sm:text-2xl md:text-3xl">
                  “{active.text}”
                </p>
                <div className="mt-8 flex items-center gap-4">
                  <span className="h-px w-10 bg-brand-accent" />
                  <div>
                    <div className="font-heading text-lg font-bold text-brand-primary">
                      {active.name}
                    </div>
                    <div className="text-sm text-brand-primary/55">Elégedett ügyfél</div>
                  </div>
                </div>
              </motion.blockquote>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
}
